export default "__VITE_ASSET__OmADD$y$__"